import { __rest, __assign } from 'tslib';
import React, { useState } from 'react';
import cn from 'classnames';
import { TRow } from '../trow/Component.js';

var styles = {"row":"table__row_1a2ql","selected":"table__selected_1a2ql","expanded":"table__expanded_1a2ql","expandable":"table__expandable_1a2ql"};
require('./index.css');

var TExpandableRow = function (_a) {
    var _b, _c;
    var className = _a.className, selected = _a.selected, expanded = _a.expanded, _d = _a.defaultExpanded, defaultExpanded = _d === void 0 ? false : _d, _e = _a.onToggle, onToggle = _e === void 0 ? function () { return null; } : _e, _f = _a.renderContent, renderContent = _f === void 0 ? function () { return null; } : _f, restProps = __rest(_a, ["className", "selected", "expanded", "defaultExpanded", "onToggle", "renderContent"]);
    var _g = useState(defaultExpanded), expandedState = _g[0], setExpandedState = _g[1];
    var uncontrolled = expanded === undefined;
    var isExpanded = (uncontrolled ? expandedState : expanded);
    var handleToggle = function () {
        if (uncontrolled) {
            setExpandedState(!isExpanded);
        }
        onToggle(isExpanded);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TRow, __assign({ className: cn(styles.row, className, (_b = {},
                _b[styles.selected] = selected,
                _b[styles.expanded] = isExpanded,
                _b)), selected: selected, onClick: handleToggle }, restProps)),
        React.createElement("tr", { className: cn(styles.expandable, (_c = {}, _c[styles.expanded] = isExpanded, _c)) }, renderContent(isExpanded))));
};

export { TExpandableRow };
